// extracted by mini-css-extract-plugin
module.exports = {"tab":"_1B2CT","active":"_1DjPO","tabSkeleton":"_249vX","activeTab":"_3bw4t","videoGalleryTab":"_1vzYN"};